import { NgModule } from '@angular/core';
import { NotificationsComponent } from './notifications.component';
import { NotificationsService } from './notifications.service';
// import { SharedModule } from '@Shared/shared.module';



@NgModule({
    imports: [  NotificationsComponent],
    providers: [NotificationsService,NotificationsComponent],
})
export class NotificationsModule {}
